<template><span class="draft-badge">Draft</span></template>

<script>
export default { name: 'DraftBadge' };
</script>

<style scoped>
.draft-badge { background: #f0b13c; border: 1px solid #ffd27a; border-radius: 999px; color: #1b1204; display: inline-block; font-family: "Oswald", sans-serif; font-size: .7rem; font-weight: 900; letter-spacing: .06em; padding: 5px 9px; text-transform: uppercase; }
</style>
